import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { DeliveredListResponse } from '@shared/schemas';

import { compareDeliveredLists } from '../domain/delivered-list-order';
import { initialState } from './discovered-lps.state';

/**
 * Discovered LPs Index slice. Reducers are pure state transitions only; the
 * fetch itself lives in the saga, which dispatches these `load*` transitions
 * as it progresses.
 */
const slice = createSlice({
  name: 'discoveredLps',
  initialState,
  reducers: {
    loadStarted: (state) => {
      state.loading = true;
      state.error = null;
    },
    /** In the table's default order: list number, highest first (#712). */
    loadSucceeded: (state, action: PayloadAction<DeliveredListResponse[]>) => {
      state.rows = [...action.payload].sort(compareDeliveredLists);
      state.loading = false;
    },
    loadFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const discoveredLpsActions = slice.actions;
export const discoveredLpsReducer = slice.reducer;
